// removed by extract-text-webpack-plugin
module.exports = {"ListItem":"_3ZJ32"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Baggage/BaggagePaxSelect/BaggagePaxSelect.scss
// module id = 605
// module chunks = 0